@let infoboxData = verificationStatusMap.get(companyVerificationStatus()!);

@if (shouldShowVerificationInfobox() && infoboxData) {
  <rt-infobox
    [isDismissible]="false"
    [type]="infoboxData.infoboxType"
    [iconName]="infoboxData.iconName"
  >
    <div layout-vertical>
      <span class="heading">{{ infoboxData.heading }}</span>
      <span class="subheading">{{ infoboxData.subheading }}</span>
      @if (infoboxData.ctaLabel) {
        <rt-button variant="tertiary" (click)="ctaButtonClicked()"
          >{{ infoboxData.ctaLabel }}
        </rt-button>
      }
    </div>
  </rt-infobox>
}
